export default {"src":"/_next/static/media/handbiken.9eea76df.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};